import axios from 'axios';

export async function request(options) {
  try {
    console.log(`[API] request: ${JSON.stringify(options, null, 2)}`);
    const result = await axios(options);
    console.log(`[API] status: ${result?.status}`);
    return result;
  } catch (err) {
    const status = err?.response?.status;
    // const data = err?.response?.data;
    const msg = err?.message ?? err;

    const log = [
      status ? `status: ${status}` : null,
      // data ? `data: ${JSON.stringify(data)}` : null,
      msg ? `msg: ${msg}` : null
    ]
      .filter((el) => !!el)
      .join(', ');

    console.log(`[API] error ${log}`);

    throw err;
  }
}

export const getHost = () => {
  // local
  if (/:\d{4,}$/.test(window.location.origin)) {
    const r = window.location.origin.split(/:\d{4,}/);
    // if (r[0]) {
    // return `${r[0]}:5000`;
    // }
    return 'https://dev-a512b8beacd7.sandshour.com';
  }

  // dev
  if (/^dev-/.test(window.location.host)) {
    return 'https://dev-a512b8beacd7.sandshour.com';
  }

  // pro
  return window.location.origin;
};
